import React, { useEffect, useState } from 'react';
import Button from '../../../components/ui/Button';
import { IconUploader } from './IconUploader';
import { listingCategoriesService } from '../../../services/listing-categories.service';
import { ListingCategory } from '../../../interfaces/listing-category.interface';

interface ConfigSettingsTabProps {
  icon: string;
  remark: string;
  listingCategoryId: string | null;
  saving: boolean;
  onIconChange: (v: string) => void;
  onRemarkChange: (v: string) => void;
  onListingCategoryChange: (v: string | null) => void;
  onSave: () => void;
}

export const ConfigSettingsTab = ({
  icon,
  remark,
  listingCategoryId,
  saving,
  onIconChange,
  onRemarkChange,
  onListingCategoryChange,
  onSave,
}: ConfigSettingsTabProps) => {
  const [categories, setCategories] = useState<ListingCategory[]>([]);

  useEffect(() => {
    listingCategoriesService.list()
      .then(setCategories)
      .catch(() => {}); // non-critical
  }, []);

  return (
    <div className="flex flex-col gap-4 p-4 max-w-md">
      {/* Icon Uploader */}
      <IconUploader
        label="Config Icon"
        value={icon}
        onChange={onIconChange}
      />

      {/* Remark Textarea */}
      <div>
        <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
          Remark (admin notes)
        </label>
        <textarea
          rows={3}
          className="w-full border border-gray-300 dark:border-gray-600 rounded px-2 py-1.5 text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none"
          placeholder="Internal notes about this config…"
          value={remark}
          onChange={(e) => onRemarkChange(e.target.value)}
        />
      </div>

      {/* Listing Category Dropdown */}
      <div>
        <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
          Listing Category
        </label>
        <select
          className="w-full border border-gray-300 dark:border-gray-600 rounded px-2 py-1.5 text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 focus:outline-none"
          value={listingCategoryId ?? ''}
          onChange={(e) => onListingCategoryChange(e.target.value || null)}
        >
          <option value="">-- No Category --</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.key}
            </option>
          ))}
        </select>
        <p className="mt-1 text-xs text-gray-400">
          Assigns this form config to a listing category (determines app nav section).
        </p>
      </div>

      {/* Save Button */}
      <Button
        variant="primary"
        size="sm"
        disabled={saving}
        onClick={onSave}
      >
        {saving ? 'Saving…' : 'Save Settings'}
      </Button>
    </div>
  );
};

export default ConfigSettingsTab;
